module.exports = __webpack_public_path__ + "static/img/noTest.f9810db.png";


//////////////////
// WEBPACK FOOTER
// ./static/20210517new/noTest.png
// module id = erSC
// module chunks = 14